module.exports = __webpack_public_path__ + "static/media/iconpcd.d1a1f24d.svg";